import { Modal, ModalProps } from 'antd';
import styled from 'styled-components';

import { CloseOutlined } from '@ant-design/icons';

import { useDisplayContext } from '~src/context/DisplayContext';

import { Heading } from '../Typography';

const TitleContainer = styled.div<{ isMobile?: boolean }>(({ isMobile }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: isMobile ? 'flex-start' : 'center',
}));

type ModalBaseProps = ModalProps & {
  setVisible?: (visible: false) => void;
  background?: string;
  maxWidth?: string | number;
};

export const ModalBase = ({
  title,
  children,
  width = '90%',
  footer = null,
  closeIcon = <CloseOutlined style={{ fontSize: 22, padding: '24px 32px 0 0' }} />,
  background,
  onCancel,
  setVisible,
  maxWidth,
  closable,
  style,
  ...rest
}: ModalBaseProps) => {
  const { isMobile } = useDisplayContext();

  return (
    <Modal
      {...{
        isMobile,
        centered: true,
        title: title ? (
          <TitleContainer {...{ isMobile }}>
            <Heading style={{ width: '80%', ...(isMobile && { textAlign: 'left' }) }} as='h1'>
              {title}
            </Heading>
          </TitleContainer>
        ) : (
          <></>
        ),
        width,
        footer,
        closeIcon: closable || !isMobile ? closeIcon : undefined,
        closable: closable && !!setVisible,
        background,
        onCancel: setVisible ? () => setVisible(false) : onCancel,
        style: { ...(style ?? {}), maxWidth },
        ...rest,
      }}
    >
      {children}
    </Modal>
  );
};
